import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';

function formatChange(log) {
  if (log.action==='LOGIN') return 'Logged in';
  if (log.action==='CREATE') return `Created ${log.entity_type}`;
  if (log.action==='DELETE') return `Deleted ${log.entity_type}`;
  if (log.action==='UPDATE') {
    try {
      const oldV = typeof log.old_value==='string'?JSON.parse(log.old_value):log.old_value||{};
      const newV = typeof log.new_value==='string'?JSON.parse(log.new_value):log.new_value||{};
      const changes = Object.keys(newV).filter(k=>JSON.stringify(oldV[k])!==JSON.stringify(newV[k])).map(k=>`${k}: "${String(oldV[k]||'').slice(0,30)}" → "${String(newV[k]||'').slice(0,30)}"`);
      return changes.length?changes.join(' | '):`Updated ${log.entity_type}`;
    } catch { return `Updated ${log.entity_type}`; }
  }
  return log.action;
}

export default function AuditPage() {
  const [entityType, setEntityType] = useState('');
  const [search, setSearch] = useState('');
  const { data=[], isLoading } = useQuery({
    queryKey:['audit',entityType,search],
    queryFn:()=>api.get(`/reports/audit?limit=300${entityType?'&entityType='+entityType:''}${search?'&search='+search:''}`).then(r=>r.data),
  });

  const actionColor = { CREATE:'pill-green', DELETE:'pill-red', UPDATE:'pill-orange', LOGIN:'pill-blue' };

  return (
    <div>
      <div className="section-head">
        <h2>Audit log</h2>
        <span style={{fontSize:12,color:'var(--text2)'}}>{data.length} records</span>
      </div>
      <div style={{display:'flex',gap:8,marginBottom:14,flexWrap:'wrap'}}>
        <input placeholder="Search by user name…" value={search} onChange={e=>setSearch(e.target.value)} style={{flex:1,minWidth:140}}/>
        <select value={entityType} onChange={e=>setEntityType(e.target.value)} style={{minWidth:130}}>
          <option value="">All types</option>
          <option value="entry">Entries</option>
          <option value="client">Clients</option>
          <option value="user">Users</option>
          <option value="category">Categories</option>
          <option value="hierarchy_node">Hierarchy nodes</option>
        </select>
      </div>
      <div className="tbl-wrap">
        <table>
          <thead><tr><th>Date & time</th><th>User</th><th>Action</th><th>Type</th><th>What changed</th></tr></thead>
          <tbody>
            {isLoading?<tr><td colSpan={5}><div className="empty"><div className="spinner"/></div></td></tr>
            :data.length===0?<tr><td colSpan={5}><div className="empty">No audit records found</div></td></tr>
            :data.map(log=>(
              <tr key={log.id}>
                <td style={{fontSize:11,color:'var(--text2)',whiteSpace:'nowrap'}}>{new Date(log.created_at).toLocaleString('en-IN')}</td>
                <td style={{fontWeight:500,fontSize:13}}>{log.user_name||'System'}</td>
                <td><span className={`pill ${actionColor[log.action]||'pill-gray'}`}>{log.action}</span></td>
                <td style={{fontSize:12,color:'var(--text2)'}}>{log.entity_type}</td>
                <td style={{fontSize:12,color:'var(--text2)',maxWidth:320,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{formatChange(log)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
